const str = '';
const decimal = 0.00;
const dateTimeStr = new Date()?.toISOString();

export const inventoryModelGet = ({ id = '', userId = '', }) => {
    return {
        id: id,
        userId: userId,
        brand: str,
        cost: decimal,
        created: dateTimeStr,
        description: str,
        manufactured: dateTimeStr,
        model: str,
        serial: str,
        type: str,
    }
};